import { _pHttp } from "../_pHttp";

export async function addMatch(body: any) {
  await _pHttp.post(`/ticket-matches`, body);
}
export const getMatches = async () => {
  const { data } = await _pHttp.get(`ticket-matches/all`);
  return data;
};

export const getMatchesWithQs = async ({ page, numberInPage, search }: any) => {
  const { data } = await _pHttp.get(
    `ticket-matches?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};
export async function editMatch(body: any) {
  return _pHttp.patch(`/ticket-matches/${body.id}`, body);
}
export async function deleteMatch(id: any) {
  return _pHttp.delete(`/ticket-matches/${id}`);
}
export const getFinisedMatches = async ({
  page,
  numberInPage,
  search,
  timeFrame,
}: any) => {
  const { data } = await _pHttp.get(
    `ticket-matches?page=${page}&numberInPage=${numberInPage}&search=${search}&timeFrame=${timeFrame}`
  );
  return data;
};
export const saleUpdate = async (matchId: any) => {
  const data = await _pHttp.get(`ticket-matches/saleUpdate/${matchId}`);
  return data;
};

export const getTicketCurrentDetailed = async (isMale: boolean) => {
  const data = await _pHttp.get(`ticket-matches/currentDetailed?male=${isMale}`);
  return data;
};
export const getTicketCurrentDetailedSpecial = async (isMale: boolean) => {
  const data = await _pHttp.get(`ticket-matches/currentDetailed?male=${isMale}&&home=true`);
  return data;
};